import template from './hueb-seo-category.html.twig';

const { Component, Mixin } = Shopware;
const { Criteria } = Shopware.Data;

Component.register('hueb-seo-category', {
    template,

    inject: [ 'repositoryFactory', 'systemConfigApiService' ],

    mixins: [ Mixin.getByName('notification') ],

    metaInfo() {
        return {
            title: this.$createTitle()
        };
    },

    data() {
        return {
            categoryId: null,
            isLoadingGenerate: false,
            isLoadingTemplate: false,
            isLoadingNewTemplate: false,
            isBig: false,
            bigProgress: 0,
            blockSize: 100,
            processSuccess: false,
            currentLanguageId: Shopware.Context.api.languageId,
            checkedElements: {},
            checkedElementsBool: true,
            childList: {},
            categoryRepository: null,
            templateRepository: null,
            templateSaveRepository: null,
            robotsTagRepository: null,
            salesChannelDomainRepository: null,
            metaTitle: '',
            metaDescription: '',
            keywords: '',
            metaTitleActive: false,
            metaDescriptionActive: false,
            keywordsActive: false,
            metaTitleVariables: [],
            metaDescriptionVariables: [],
            keywordsVariables: [],
            includeChildren: false,
            overwrite: false,
            categoryOptions: [],
            templateName: '',
            templateOptions: [],
            templateSelected: null,
            metaTitlePreview: this.$tc('hueb-seo.card.labelMetaTitle'),
            metaDescriptionPreview: this.$tc('hueb-seo.card.labelMetaDescription'),
            keywordsPreview: '',
            previewEntity: null,
            seoUrl: this.$tc('hueb-seo.general.placeholderNoUrl'),
            robotOptions: [],
            robotSelected: null,
            cleanNames: [],
            whitelist: []
        };
    },

    created() {
        this.createdComponent();
    },

    methods: {
        createdComponent() {
            this.setCleanNames();
            this.setWhitelist();
            this.categoryRepository = this.repositoryFactory.create('category');
            this.templateRepository = this.repositoryFactory.create('hueb_seo_ultimate_templates');
            this.templateSaveRepository = this.repositoryFactory.create('hueb_seo_ultimate_templates_saved');
            this.salesChannelDomainRepository = this.repositoryFactory.create('sales_channel_domain');
            this.robotsTagRepository = this.repositoryFactory.create('hueb_seo_ultimate_robot_tags');
            this.robotOptions = [{value: '00', label: this.$tc('hueb-seo.card.robot00')},
                                 {value: '01', label: this.$tc('hueb-seo.card.robot01')},
                                 {value: '10', label: this.$tc('hueb-seo.card.robot10')},
                                 {value: '11', label: this.$tc('hueb-seo.card.robot11')}];
            this.createVariableOptions(this.categoryRepository,"category");
            this.createTemplateOptions("category");
        },

        setCleanNames() {
            this.cleanNames = [
                {value: "category.name", label: "Kategoriename"},
                {value: "category.translated.name", label: "Kategoriename (Übersetzung)"},
                {value: "category.type", label: "Kategorietyp"},
                {value: "category.keywords", label: "Keywords"}
            ]
        },
        setWhitelist() {
            this.whitelist = [
                "category.path",
                "category.type",
                "category.productAssignmentType",
                "category.name",
                "category.customFields",
                "category.slotConfig",
                "category.externalLink",
                "category.description",
                "category.keywords",
                "category.translated.name",
                "category.translated.slotConfig",
                "category.translated.externalLink",
                "category.translated.description",
                "category.translated.keywords",
                "category.id"
            ]
        },
        createVariableOptions(repository, type) {
            const categoryCriteria = new Criteria();
            //categoryCriteria.addFilter(Criteria.equals('autoIncrement', 1));
            repository.search(categoryCriteria, Shopware.Context.api)
                .then((entity) => {

                    const pushVariables = (objectEntries, parent = '') => {
                        for (const [key, value] of objectEntries) {
                            if(!Array.isArray(value) && (typeof value != 'object' || value == null)) {
                                const variableString = type + '.' + parent + key;

                                if(this.whitelist.indexOf(variableString) === -1) {
                                    continue;
                                }

                                const variableValue = '{{ ' + variableString + ' }}';
                                let variableLabel = this.cleanNames.find(o => o.value === variableString);
                                if (typeof variableLabel === 'undefined') {
                                    variableLabel = variableString;
                                } else {
                                    variableLabel = variableLabel.label + ' (' + variableString + ')';
                                }

                                this.categoryOptions.push({value: variableValue, label: variableLabel})
                            } else if (!Array.isArray(value) && typeof value == 'object' && value != null) {
                                pushVariables(Object.entries(value), key + '.');
                            }

                        }
                    };
                    pushVariables(Object.entries(entity[0]));
                });
        },
        createTemplateOptions(type) {
            this.templateOptions = [];
            this.templateSaveRepository.search(new Criteria(), Shopware.Context.api)
                .then((entity) => {
                    entity.forEach((template) => {
                        if(template.type === type) {
                            this.templateOptions.push({value: template.id, label: template.name});
                        }
                    });
                    if(this.templateOptions.length === 0) {
                        this.templateOptions.push({value: 'default', label: this.$tc('hueb-seo.general.emptyTemplateOptions')});
                    }
                });
        },
        createSalesChannel() {
            if(this.previewEntity && this.previewEntity['seoUrls'][0]) {
                const channelCriteria = new Criteria();
                channelCriteria.addFilter(Criteria.equals('salesChannelId', this.previewEntity['seoUrls'][0]['salesChannelId']));
                this.salesChannelDomainRepository.search(channelCriteria, Shopware.Context.api)
                    .then((entity) => {
                        let salesChannel = 'https://shopUrl.com';
                        if (entity.length) {
                            salesChannel = entity[0].url;
                            entity.forEach((entry) => {
                                if(entry.languageId === Shopware.Context.api.languageId) {
                                    salesChannel = entry.url;
                                }
                            });
                        }
                        let urlString;
                        const seoPathInfo = this.previewEntity['seoUrls'][0]['seoPathInfo'];
                        const pathInfo = this.previewEntity['seoUrls'][0]['pathInfo'];
                        if (seoPathInfo) {
                            urlString = salesChannel + '/' + seoPathInfo;
                        } else {
                            urlString = salesChannel + '/' + pathInfo;
                        }
                        this.seoUrl = urlString;
                    });
            } else {
                this.seoUrl = this.$tc('hueb-seo.general.placeholderNoUrl');
            }
        },

        onSelectMetaTitleVariable(selected) {
            if (selected)
                this.metaTitle += selected;
            this.onChangeMetaTitle();
        },
        onSelectMetaDescriptionVariable(selected) {
            if (selected)
                this.metaDescription += selected;
            this.onChangeMetaDescription();
        },
        onSelectKeywordsVariable(selected) {
            if (selected)
                this.keywords += selected;
            this.onChangeKeywords();
        },
        onChangeLanguage(newLanguageId) {
            this.currentLanguageId = newLanguageId;
            this.checkedElements = {};
        },
        onSelectTemplate(selected) {
            if (selected && selected !== 'default') {
                this.templateSaveRepository.get(selected, Shopware.Context.api)
                    .then((entity) => {
                        this.metaTitle = entity.metaTitle;
                        this.metaDescription = entity.metaDescription;
                        this.keywords = entity.keywords;
                        if(this.metaTitle)
                            this.metaTitleActive = true;
                        if(this.metaDescription)
                            this.metaDescriptionActive = true;
                        if(this.keywords)
                            this.keywordsActive = true;
                        this.updatePreview();
                    });
            } else {
                this.metaTitle = '';
                this.metaDescription = '';
                this.keywords = '';
                this.updatePreview();
            }
        },
        updatePreview() {
            this.onChangeMetaTitle();
            this.onChangeMetaDescription();
            this.onChangeKeywords();
            this.createSalesChannel();
        },

        checkItem(item) {
            if (item.checked) {
                this.checkedElements[item.id] = item;
            } else {
                delete this.checkedElements[item.id];
            }
            if(Object.keys(this.checkedElements).length === 0 && this.checkedElements.constructor === Object) {
                this.checkedElementsBool = true;
            } else {
                this.checkedElementsBool = false;
            }
        },
        clickItem(item) {
            const categoryCriteria = new Criteria();
            categoryCriteria.addAssociation('seoUrls');
            this.categoryRepository.get(item.id, Shopware.Context.api, categoryCriteria)
                .then((entity) => {
                    this.previewEntity = entity;
                    this.updatePreview();
                });


            /*this.templateRepository.get(item.id, Shopware.Context.api)
                .then((entity) => {
                    if(entity) {
                        if(entity.templateCategoryMetaTitle) {
                            this.metaTitle = entity.templateCategoryMetaTitle;
                        } else {
                            this.metaTitle = '';
                        }
                        if(entity.templateCategoryMetaDescription) {
                            this.metaDescription = entity.templateCategoryMetaDescription;
                        } else {
                            this.metaDescription = '';
                        }
                        if(entity.templateCategoryKeywords) {
                            this.keywords = entity.templateCategoryKeywords;
                        } else {
                            this.keywords = '';
                        }
                    } else {
                        this.metaTitle = '';
                        this.metaDescription = '';
                        this.keywords = '';
                    }
                })*/
        },
        onChangeMetaTitle() {
            this.setVariables();
            if(this.metaTitle && this.previewEntity) {
                this.metaTitlePreview = this.getVariables(this.metaTitle, this.metaTitleVariables, this.previewEntity);
            } else if(!this.previewEntity) {
                this.metaTitlePreview = this.$tc('hueb-seo.general.placeholderPreview');
            } else {
                this.metaTitlePreview = this.$tc('hueb-seo.card.labelMetaTitle');
            }
        },
        onChangeMetaDescription() {
            this.setVariables();
            if(this.metaDescription && this.previewEntity) {
                this.metaDescriptionPreview = this.getVariables(this.metaDescription, this.metaDescriptionVariables, this.previewEntity);
            } else if(!this.previewEntity) {
                this.metaDescriptionPreview = this.$tc('hueb-seo.general.placeholderPreview');
            } else {
                this.metaDescriptionPreview = this.$tc('hueb-seo.card.labelMetaDescription');
            }
        },
        onChangeKeywords() {
            this.setVariables();
            this.keywordsPreview = this.getVariables(this.keywords, this.keywordsVariables, this.previewEntity);
            if(!this.previewEntity && this.keywordsActive) {
                this.keywordsPreview = this.$tc('hueb-seo.general.placeholderPreview');
            }
        },

        addChildren(checkedElements) {
            return new Promise((resolve) => {

                let arr = Object.keys(checkedElements);

                arr.forEach((parent, key, arr) => {
                    delete this.tempList[parent];

                    const categoryCriteria = new Criteria(1, 500);
                    categoryCriteria.addFilter(Criteria.equals('parentId', parent));

                    this.categoryRepository.search(categoryCriteria, Shopware.Context.api)
                        .then((children) => {
                            children.forEach((child) => {
                                if(child.childCount) {
                                    this.tempList[child.id] = child;
                                }
                                this.childList[child.id] = child;
                            });
                            //fire on last entry
                            if (Object.is(arr.length - 1, key)) {
                                return resolve(true);
                            }
                        })
                        .catch((exception) => {
                            this.isLoadingGenerate = false;
                            this.createNotificationError({
                                title: this.$tc('hueb-seo.general.placeholderError'),
                                message: exception
                            });
                        });
                });
            })
        },

        setVariables() {
            const regexp = /\{\{(.*?)\}\}/g;

            this.metaTitleVariables = [];
            this.metaDescriptionVariables = [];
            this.keywordsVariables = [];

            if(this.metaTitleActive && this.metaTitle)
                this.metaTitleVariables = Array.from(this.metaTitle.matchAll(regexp));
            if(this.metaDescriptionActive && this.metaDescription)
                this.metaDescriptionVariables = Array.from(this.metaDescription.matchAll(regexp));
            if(this.keywordsActive && this.keywords)
                this.keywordsVariables = Array.from(this.keywords.matchAll(regexp));

            this.metaTitleVariables.forEach(item => {
                let splitStr = item[1].replace(/\s+|(category\.)/g, '').toString();
                item[1] = splitStr.split(".");
            });
            this.metaDescriptionVariables.forEach(item => {
                let splitStr = item[1].replace(/\s+|(category\.)/g, '').toString();
                item[1] = splitStr.split(".");
            });
            this.keywordsVariables.forEach(item => {
                let splitStr = item[1].replace(/\s+|(category\.)/g, '').toString();
                item[1] = splitStr.split(".");
            });
        },
        getVariables(inputString, variableArray, entity) {
            variableArray.forEach(item => {
                if(entity) {
                    let solvedVariable = entity[item[1][0]];
                    item[1].forEach((nested, key) => {
                        if (key > 0) {
                            solvedVariable = solvedVariable[nested];
                        }
                    });
                    const type = typeof solvedVariable;
                    if (type === 'string' || type === 'number' || type === 'boolean') {
                        inputString = inputString.replace(item[0], solvedVariable);
                    } else {
                        solvedVariable = '';
                        inputString = inputString.replace(item[0], solvedVariable);
                    }
                }
            });
            return String(inputString);
        },

        onClickSaveTemplate() {
            this.isLoadingTemplate = true;
            if (this.templateSelected && this.templateSelected !== 'default') {
                this.templateSaveRepository.get(this.templateSelected, Shopware.Context.api)
                    .then((entity) => {
                        entity.metaTitle = this.metaTitle;
                        entity.metaDescription = this.metaDescription;
                        entity.keywords = this.keywords;

                        this.templateSaveRepository.save(entity, Shopware.Context.api)
                            .then(() => {
                                this.isLoadingTemplate = false;
                            });
                    });
            }
            this.isLoadingTemplate = false;
        },
        onClickDeleteTemplate() {
            if (this.templateSelected && this.templateSelected !== 'default') {
                this.templateSaveRepository.delete(this.templateSelected, Shopware.Context.api)
                    .then(() => {
                        this.createTemplateOptions();
                    });
            }
        },
        onClickSaveNewTemplate(name = null) {
            this.isLoadingNewTemplate = true;

            const templateCriteria = new Criteria();
            templateCriteria.addFilter(Criteria.equals('name', this.templateName));

            this.templateSaveRepository.search(templateCriteria, Shopware.Context.api)
                .then((entity) => {
                    if (entity.length === 0 || entity[0].type !== "category") {
                        entity = this.templateSaveRepository.create(Shopware.Context.api);
                        entity.name = this.templateName;
                        entity.type = "category";
                    } else {
                        entity = entity[0];
                    }
                    entity.metaTitle = this.metaTitle;
                    entity.metaDescription = this.metaDescription;
                    entity.keywords = this.keywords;
                    this.templateSaveRepository.save(entity, Shopware.Context.api)
                        .then(() => {
                            this.createTemplateOptions("category");
                            this.isLoadingNewTemplate = false;
                        })
                        .catch((exception) => {
                            this.isLoadingNewTemplate = false;
                            this.createNotificationError({
                                title: this.$tc('hueb-seo.general.placeholderError'),
                                message: exception
                            });
                        });
                });
        },

        onClickGenerate() {
            this.isLoadingGenerate = true;

            this.setVariables();

            this.childList = {};
            this.tempList = {};

            if(this.includeChildren) {
                const collectChildren = (parents = this.checkedElements) => {
                    this.addChildren(parents).then((bool) => {
                        if(Object.keys(this.tempList).length === 0 && this.tempList.constructor === Object && bool) {
                            this.saveGenerate();
                        } else if(bool) {
                            collectChildren(this.tempList);
                        }
                    });
                };
                collectChildren();

            } else {
                this.childList = {};
                this.saveGenerate();
            }
        },
        saveGenerate() {
            let childIds = Object.keys(this.childList);
            let ids = Object.keys(this.checkedElements);
            //prohibit duplicates
            ids = childIds.concat(ids.filter((item) => childIds.indexOf(item) < 0));

            let categoryCriteria = new Criteria(1, ids.length);
            categoryCriteria.addFilter(Criteria.equalsAny('id', ids));
            this.categoryRepository.search(categoryCriteria, Shopware.Context.api)
                .then((entities) => {
                    this.saveRobotTags(entities);
                    entities.forEach((entity) => {
                        if(this.metaTitleActive && (!entity.metaTitle || this.overwrite)) {
                            entity.metaTitle = this.getVariables(this.metaTitle, this.metaTitleVariables, entity).substring(0, 255);
                        }
                        if(this.metaDescriptionActive && (!entity.metaDescription || this.overwrite)) {
                            entity.metaDescription = this.getVariables(this.metaDescription, this.metaDescriptionVariables, entity).substring(0, 255);
                        }
                        if(this.keywordsActive && (!entity.keywords || this.overwrite)) {
                            entity.keywords = this.getVariables(this.keywords, this.keywordsVariables, entity).substring(0, 255);
                        }
                        //this.saveTemplates(entity.id);
                    });
                    this.categoryRepository.sync(entities, Shopware.Context.api)
                        .then(() => {
                            this.isLoadingGenerate = false;
                            this.processSuccess = true;
                        }).catch((exception) => {
                        this.isLoadingGenerate = false;
                        this.createNotificationError({
                            title: this.$tc('hueb-seo.general.placeholderError'),
                            message: exception
                        });
                    });
                }).catch((exception) => {
                this.isLoadingGenerate = false;
                this.createNotificationError({
                    title: this.$tc('hueb-seo.general.placeholderError'),
                    message: exception
                });
            });
        },

        saveTemplates(categoryId) {
            this.templateRepository.get(categoryId, Shopware.Context.api)
                .then((entity) => {

                    if(!entity) {
                        entity = this.templateRepository.create(Shopware.Context.api);
                        entity.id = categoryId;
                    }

                    if(this.metaTitleActive) {
                        entity.templateCategoryMetaTitle = this.metaTitle;
                    }
                    if(this.metaDescriptionActive) {
                        entity.templateCategoryMetaDescription = this.metaDescription;
                    }
                    if(this.keywordsActive) {
                        entity.templateCategoryKeywords = this.keywords;
                    }

                    this.templateRepository.save(entity, Shopware.Context.api);
                }).catch((exception) => {
                this.createNotificationError({
                    title: this.$tc('hueb-seo.general.placeholderError'),
                    message: exception
                });
            });
        },

        saveRobotTags(entities) {
            if (this.robotSelected) {
                let robotEntities = [];
                entities.forEach((categoryEntity) => {
                        let entity = this.robotsTagRepository.create(Shopware.Context.api);

                        entity.id = categoryEntity.id;
                        if (this.robotSelected === '01') {
                            entity.noindex = false;
                            entity.nofollow = true;
                        } else if (this.robotSelected === '10') {
                            entity.noindex = true;
                            entity.nofollow = false;
                        } else if (this.robotSelected === '11') {
                            entity.noindex = true;
                            entity.nofollow = true;
                        } else {
                            entity.noindex = false;
                            entity.nofollow = false;
                        }

                        robotEntities.push(entity);
                });
                this.robotsTagRepository.sync(robotEntities, Shopware.Context.api);
            }
        },

        saveFinish() {
            this.processSuccess = false;
        }

    }

});
